import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={800}
    height={800}
    viewBox="0 0 482.14 482.14"
    {...props}
    fill="none"
    stroke={'none'}>
    <Path
      fill={props.fill || '#000'}
      d="M302.598 0H108.967C80.661 0 57.652 23.025 57.652 51.315v379.509c0 28.289 23.009 51.315 51.315 51.315h264.205c28.274 0 51.315-23.026 51.315-51.315V121.449L302.598 0zm70.574 450.698H108.967c-10.97 0-19.891-8.905-19.891-19.874V51.315c0-10.953 8.921-19.858 19.891-19.858l181.874-.189v67.218c0 19.653 15.949 35.603 35.587 35.603l65.878-.189.725 296.925c0 10.968-8.889 19.873-19.859 19.873z"
    />
    <Path
      fill={props.fill || '#000'}
      d="M297.413 246.059h-24.634v-73.058c0-7.414-6.004-13.42-13.411-13.42h-36.626c-7.392 0-13.396 6.006-13.396 13.42v73.058H184.71c-4.065 0-7.723 2.458-9.299 6.225a10.051 10.051 0 0 0 2.191 10.978l56.327 56.335c3.94 3.94 10.323 3.94 14.247 0l56.359-56.335a10.106 10.106 0 0 0 2.191-10.978c-1.574-3.767-5.246-6.225-9.313-6.225z"
    />
  </Svg>
);
export default SvgComponent;
